import React from 'react';
import SharedTimeOffCalendar from '../calendar/SharedTimeOffCalendar';

function OperationalSharedCalendar({
  locationCode,
  locationLabel,
  subtitle = 'Shared calendar for approved time off, blackout dates, and visible coverage-rule markers.',
  title = 'Shared Time-Off Calendar',
  workspaceLabel = 'Workspace'
}) {
  return (
    <SharedTimeOffCalendar
      locationCode={locationCode}
      locationLabel={locationLabel}
      roleLabel={workspaceLabel}
      subtitle={subtitle}
      title={title}
    />
  );
}

export default OperationalSharedCalendar;
